/**
 * Stamps theme classes onto countdown sentences.
 *
 * Belongs here: which token each countdown sentence uses for Prime vs Rebalance.
 * Does not belong here: the English for a specific plan (that stays on the panel).
 */

import type { PlansTheme } from '../../header/common/riskProfileHeaderTheme'

export type TimerColoredText = {
  text: string
  className: string
}

type TimerCountdownSentences = {
  readyIn: string
  delayTitle: string
  delayBody: string
  unlockPrompt: string
}

export type TimerCountdownChrome = {
  readyIn: TimerColoredText
  delayTitle: TimerColoredText
  delayBody: TimerColoredText
  notify: TimerColoredText
  unlockPrompt: TimerColoredText
  digitClassName: string
  unitLabelClassName: string
  shadowClassName: string
  trustedByClassName: string
}

const NOTIFY_TEXT = 'We will notify you once your plan is ready'

/** Prime countdown: ready-in, delay title, digits, notify, and trusted-by use primary. Delay body and the unlock line use dark. */
export function primeTimerCountdownChrome(
  theme: PlansTheme,
  sentences: TimerCountdownSentences
): TimerCountdownChrome {
  return {
    readyIn: { text: sentences.readyIn, className: theme.primaryTextClassName },
    delayTitle: { text: sentences.delayTitle, className: theme.primaryTextClassName },
    delayBody: { text: sentences.delayBody, className: theme.primaryDarkTextClassName },
    notify: { text: NOTIFY_TEXT, className: theme.primaryTextClassName },
    unlockPrompt: { text: sentences.unlockPrompt, className: theme.primaryDarkTextClassName },
    digitClassName: theme.primaryTextClassName,
    unitLabelClassName: theme.primaryTextClassName,
    shadowClassName: theme.primaryDarkShadowClassName,
    trustedByClassName: theme.primaryTextClassName
  }
}

/** Rebalance countdown: ready-in, delay title, and unit labels use primary. Digits, notify, trusted-by, delay body, and the unlock line use dark. */
export function rebalanceTimerCountdownChrome(
  theme: PlansTheme,
  sentences: TimerCountdownSentences
): TimerCountdownChrome {
  return {
    readyIn: { text: sentences.readyIn, className: theme.primaryTextClassName },
    delayTitle: { text: sentences.delayTitle, className: theme.primaryTextClassName },
    delayBody: { text: sentences.delayBody, className: theme.primaryDarkTextClassName },
    notify: { text: NOTIFY_TEXT, className: theme.primaryDarkTextClassName },
    unlockPrompt: { text: sentences.unlockPrompt, className: theme.primaryDarkTextClassName },
    digitClassName: theme.primaryDarkTextClassName,
    unitLabelClassName: theme.primaryTextClassName,
    shadowClassName: theme.primaryDarkShadowClassName,
    trustedByClassName: theme.primaryDarkTextClassName
  }
}
